import SanityImage from '@sanity-image';
import cn from 'classnames';
import { Link } from 'src/navigation';
import styles from './image.module.scss';
import RichTextInline from 'components/rich-text/rich-text-inline-only';
import type { Image } from '@sanity/types';

const PTImage = ({
	value,
	preventUpscale = false,
}: {
	value: IPortableTextImage;
	preventUpscale?: boolean;
}) => {
	if (!value?.asset) {
		return null;
	}

	const maxWidth = value?.maxWidth || '100%';
	return (
		<div className={cn(styles.imageWrapper, { extraLarge: value.extraLarge })}>
			<figure style={{ maxWidth: maxWidth }} className={styles.figure}>
				{value.link ? (
					<Link href={value.link}>
						<SanityImage
							alt={value.alt}
							sizes="(max-width: 960px) 90vw, 1200px"
							image={value}
							preventUpscale={preventUpscale}
						/>
					</Link>
				) : (
					<SanityImage
						alt={value.alt}
						sizes="(max-width: 960px) 90vw, 1200px"
						image={value}
						preventUpscale={preventUpscale}
					/>
				)}

				{value.imageCaption && (
					<figcaption className={styles.imgCaption}>
						<RichTextInline value={value.imageCaption} />
					</figcaption>
				)}
			</figure>
		</div>
	);
};

export const PreventUpscalePTImage = ({
	value,
}: {
	value: IPortableTextImage;
}) => {
	return <PTImage value={value} preventUpscale={true} />;
};

export interface IPortableTextImage extends Image {
	alt?: string;
	extraLarge?: boolean;
	imageCaption?: string;
	link?: string;
	maxWidth?: number;
}

export default PTImage;
